function isWatched(code) {
    return watchedCodes.includes(code);
}

document.addEventListener('ShoptetDOMPageContentLoaded', function() {
    customHideCart()
});
document.addEventListener('ShoptetPageSortingChanged', function() {
    customHideCart();
});
document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
    customHideCart();
});
$(document).ready(function(){
    customHideCart();
})
document.addEventListener('dkLabProductComparerProductsChanged', function() {
    customHideCart();
});

document.addEventListener('ShoptetDOMAdvancedOrderLoaded', function() {
    customHideCart();
});


if($('.type-detail').length){
    var productData = getShoptetDataLayer('product');
    var productCode = productData ? productData.code : null;

    if (productCode && isWatched(productCode)) {
        $('.p-info-wrapper .add-to-cart').remove();
        $('.customLineDetail .customBtnCart').remove();
    }
}

function customHideCart(){
    if (!$('.product').length) return;
    $('.products .product').each(function () {
        var code = $(this).find('span[data-micro="sku"]').text().trim();
        if (isWatched(code)) {
            $(this).find('.p-tools form').replaceWith(
                '<a href="' + $(this).find('a.image').attr('href') + '" class="btn btn-primary">' + translation('detail') + '</a>'
            );
        }
    });
}